module.exports = __webpack_public_path__ + "static/media/zeya_folding_arm02.d5ddfdd1.png";